// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"386":"bb0528ae","453":"706b7f5c"}[chunkId] + ".chunk.js";
};